import { Button, styled } from '@mui/material';
import {
  IPreFilter,
  isAllEmptyVals,
  DeaFilterFunction,
  DeaVoidFunction,
  IPageInfo,
  CSA_FILTER_DEF_MAX_PAGE,
} from '../common';

export const CsaFilterButtons = (props: {
  payload: IPreFilter;
  searchHandler: DeaFilterFunction;
  clearHandler: DeaVoidFunction;
  chainOption?: boolean;
}) => {
  const { payload, searchHandler, clearHandler } = props;

  const handleSearchClick = () => {
    const pageInfo: IPageInfo = {
      pageNumber: 0, // should start from beginning when search is clicked.
      pageSize: CSA_FILTER_DEF_MAX_PAGE, // get the page size set initially
    };
    searchHandler(payload, pageInfo);
  };

  const handleClearClick = () => {
    clearHandler();
  };

  return (
    <div>
      <SearchBtn
        area-label="csa-filter-search-button"
        disabled={isAllEmptyVals(payload)}
        variant="outlined"
        onClick={e => {
          e.preventDefault();
          handleSearchClick();
        }}>
        Search
      </SearchBtn>
      <Button
        area-label="csa-filter-clear-button"
        variant="outlined"
        onClick={e => {
          e.preventDefault();
          handleClearClick();
        }}>
        Clear
      </Button>
    </div>
  );
};

const SearchBtn = styled(Button)(({ theme }) => ({ marginRight: '1rem' }));
